import { render, staticRenderFns } from "./social-influencers.vue?vue&type=template&id=0e549d6a&scoped=true"
import script from "./social-influencers.vue?vue&type=script&lang=js"
export * from "./social-influencers.vue?vue&type=script&lang=js"
import style0 from "./social-influencers.vue?vue&type=style&index=0&id=0e549d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e549d6a",
  null
  
)

export default component.exports